<template>
    <div class="top-slider">
        <div class="content-wrapper slider1 hide-me">
            <div class="animated fadeIn points-hk hide-me">
                <div class="point point1"></div>
                <div class="point point2"></div>
            </div>
            <h1 class="title title-hk hide-me">始于港澳台</h1>
            <div class="points-asia hide-me"></div>
            <h1 class="title title-asia hide-me">精于东南亚</h1>
            <div class="points-global1 hide-me"></div>
            <div class="points-global2 hide-me"></div>
            <div class="points-global3 hide-me"></div>
            <h1 class="title title-global hide-me">成于全球</h1>
        </div>
        <div class="content-wrapper slider2 hide-me">
            <div class="title title-platform hide-me">打造全球顶尖游戏发行平台</div>
            <div class="dia dia1 faa-pulse animated">精品</div>
            <div class="dia dia2 faa-pulse animated">快速</div>
            <div class="dia dia3 faa-pulse animated">专业</div>
        </div>
    </div>
</template>

<script>
    export default {
        methods: {
            showSlider() {
                let that = this;
                setTimeout(function () {
                    $('.slider2').fadeOut();
                    $('.slider1').fadeIn();
                    setTimeout(function () {
                        $('.points-hk').fadeIn();
                        setTimeout(function () {
                            $('.title-hk').fadeIn();
                            setTimeout(function () {
                                $('.points-asia').fadeIn();
                                setTimeout(function () {
                                    $('.title-asia').fadeIn();
                                    setTimeout(function () {
                                        $('.points-global1').fadeIn();
                                        setTimeout(function () {
                                            $('.points-global2').fadeIn();
                                            setTimeout(function () {
                                                $('.points-global3').fadeIn();
                                                setTimeout(function () {
                                                    $('.title-global').fadeIn();
                                                    setTimeout(function () {
                                                        $('.slider1, .points-hk, .title-hk, .points-asia, .title-asia, .points-global1, .points-global2, .points-global3, .title-global').fadeOut();
                                                        setTimeout(function () {
                                                            $('.slider2').fadeIn();
                                                            setTimeout(function () {
                                                                $('.title-platform').fadeIn();
                                                                setTimeout(function () {
                                                                    $('.dia').fadeIn();
                                                                    setTimeout(function () {
                                                                        $('.slider2').fadeOut();
                                                                        that.showSlider();
                                                                    }, 4000);
                                                                }, 300);
                                                            }, 300)
                                                        }, 400);
                                                    }, 500);
                                                }, 300)
                                            }, 500)
                                        }, 300)
                                    }, 500)
                                }, 300)
                            }, 500)
                        }, 300)
                    }, 500);
                }, 500);
            }
        },
        created() {
            let that = this;
            that.showSlider();
        }
    }
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
    @import "../../assets/scss/lib.scss";

    .hide-me {
        display: none;
    }

    .top-slider {
        width: 100%;
        height: 432px;
        overflow: hidden;
        background: #020109;
        .content-wrapper {
            height: 427px;
            width: 1080px;
            margin: 0 auto;
            background-size: 1080px 432px;
            position: relative;
        }
        .slider1 {
            background: url(../../../static/img/about/about_slider1_bg.jpg);
        }
        .slider2 {
            background: url(../../../static/img/about/about_slider2_bg.jpg);
        }
    }

    .points-hk {
        width: 30px;
        height: 30px;
        position: absolute;
        top: 200px;
        right: 450px;
        .point {
            width: 5px;
            height: 5px;
            border-radius: 50%;
            background: #00fff6;
            position: absolute;
        }
        .point1 {
            top: 10px;
            left: 5px;
        }
        .point2 {
            bottom: 2px;
            right: 10px;
        }
    }

    .points-asia {
        background: url(../../../static/img/about/points_aisa.png) no-repeat top center;
        background-size: 96px 93px;
        width: 96px;
        height: 93px;
        position: absolute;
        bottom: 127px;
        right: 425px;
        display: none;
    }

    .points-global1 {
        background: url(../../../static/img/about/points_global1.png) no-repeat top center;
        background-size: 641px 277px;
        width: 641px;
        height: 277px;
        position: absolute;
        bottom: 87px;
        right: 374px;
        display: none;
    }

    .points-global2 {
        background: url(../../../static/img/about/points_global2.png) no-repeat top center;
        background-size: 703px 314px;
        width: 703px;
        height: 314px;
        position: absolute;
        bottom: 52px;
        right: 318px;
        display: none;
    }

    .points-global3 {
        background: url(../../../static/img/about/points_global3.png) no-repeat top center;
        background-size: 699px 340px;
        width: 699px;
        height: 340px;
        position: absolute;
        bottom: 25px;
        right: 322px;
    }

    .title {
        color: #fff;
        font-size: 39px;
        position: absolute;
        left: 826px;
    }

    .title-hk {
        top: 135px;
    }

    .title-asia {
        top: 208px;
    }

    .title-global {
        top: 278px;
    }

    .title-platform {
        top: 130px;
        right: 72px;
        left: auto;
    }

    .dia {
        position: absolute;
        @include flex-row-center;
        font-size: 25px;
        font-weight: bold;
    }

    .dia1 {
        background-size: 140px 140px;
        width: 140px;
        height: 140px;
        background: url(../../../static/img/about/dia1.png) no-repeat center center;
        left: 555px;
        top: 200px;
    }

    .dia2 {
        background-size: 150px 150px;
        width: 150px;
        height: 150px;
        background: url(../../../static/img/about/dia2.png) no-repeat center center;
        right: 239px;
        top: 206px;
    }

    .dia3 {
        background-size: 125px 125px;
        width: 125px;
        height: 125px;
        background: url(../../../static/img/about/dia3.png) no-repeat center center;
        right: 127px;
        top: 200px;
    }
</style>


// WEBPACK FOOTER //
// AboutSlider.vue?4beb7543